import React from "react";

export type NavbarSpecialActions =
  | {
      playbackActions: true;
    }
  | undefined;

export interface NavContextValue {
  hasBack: () => boolean;
  goBack: () => void;
  resetNavigationBoundary: () => void;
  navbarSpecialActions: NavbarSpecialActions;
  setNavbarSpecialActions: (navbarSpecialActions: NavbarSpecialActions) => void;
}

export const NavContext = React.createContext<NavContextValue>(null!);
